import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import Swal from "sweetalert2";
import { sweetAlert } from "../../Common/Utills/Utills";
import Pagination from "../../Common/Pagination/Pagination";
import AddMaterialConsumptionVal from "../MaterialConsumption/AddMaterialConsumptionVal";
import UpdateMaterialConsumptionVal from "../MaterialConsumption/UpdateMaterialConsumptionVal";
import { CSSTransition } from "react-transition-group";
import _ from "lodash";

const MaterialConsumptionVal = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [materialData, setMaterialData] = useState([]);
  const [company, setCompany] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const toggleSearch = () => {
    setShowSearch(!showSearch); // Toggle the state to show/hide search input field
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedMaterialId,
    material_id: selectedMaterialId,
  });

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/mat-consumption/all-material-consumption/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    // console.log(result.data)
    if (res.ok) {
      setTotalRecords(result.total); // Update total records count
      setRowData(result.data); // Update rowData with the actual data array
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);
  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteRow = async (id) => {
    const message = "Are you want to delete this material consumption value!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/mat-consumption/material-consumption/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    } else {
      toast.error(response.message);
      getData();
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const { id, material_id, product_id, value, company_id } = rowData;
    let BASE_URL =
      SERVER_URL + `/api/mat-consumption/material-consumption/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        material_id,
        product_id,
        company_id,
        value,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 150,
      minWidth: 205,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Product Name",
      field: "productName.size",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Company Name",
      field: "companyDetails.company_name",
      editable: false,
      valueFormatter: (params) => {
        const location = params.data.companyDetails?.location;
        const type = params.data.companyDetails?.type;
        return `${params.value}, ${location}`;
      },
      minWidth: 250,
    },
    {
      headerName: "Material Name",
      field: "raw_material.material_name",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Value",
      field: "value",
      editable: true,
      minWidth: 205,
    },
    // {
    //   headerName: "Stock Limit",
    //   field: "stock_limit",
    //   editable: true,
    //   minWidth: 205,
    // },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#editModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ company_id: "", material_id: "" });
    setSelectedCompanyId({ company_id: "" });
    setSelectedMaterialId({ material_id: "" });
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getMaterialData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setMaterialData(result.data);
    } else {
      setMaterialData([]);
    }
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
    getMaterialData();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const handleMaterialChange = (e) => {
    const materialId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedMaterialId(materialId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      material_id: materialId,
    }));
  };
  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title">
          Material Cosumption Value Table &nbsp;
          <span>
            <button
              className="btn btn-sm btn-light btn-icon-text border"
              onClick={handleRefreshClick}
            >
              Refresh{" "}
              <i
                className="mdi mdi-refresh"
                style={{ height: "4px", width: "4px" }}
              ></i>{" "}
            </button>
          </span>
        </div>
        <div className="table_btn">
          <div className="mb-3">
            <button
              data-toggle="modal"
              data-target="#exampleModal"
              className="btn btn-outline-primary"
            >
              <span className="mr-1">
                <i className="mdi mdi-briefcase-upload" />
              </span>
              Add Value
            </button>
          </div>

          <div
            style={{
              marginBottom: "20px",
            }}
          >
            <button
              onClick={() => onBtnExport()}
              className="btn btn-outline-excel mr-1 "
            >
              <span className="mr-1">
                <i className="mdi mdi-file-export"></i>
              </span>
              Export to Excel
            </button>
          </div>
        </div>

        <div className="search mb-3">
          <div className="row">
            {/* <div class="col-md-3">
                  <div class="form-group">
                  <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                  </div>
                </div> */}
            <div className="col-md-3">
              <div className="form-group">
                <select
                  className="form-control form-control-lg"
                  onChange={handleCompanyChange}
                  value={selectedCompanyId}
                >
                  <option value="">Select Company (All)</option>
                  {company &&
                    company?.length > 0 &&
                    company?.map((item, id) => {
                      return (
                        <option
                          value={item.id}
                          key={id}
                        >{`${item.company_name},${item.location}`}</option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                {/* <label htmlFor="">Material</label> */}
                <select
                  className="form-control form-control-lg"
                  onChange={handleMaterialChange}
                  value={selectedMaterialId}
                >
                  <option value="">Select Material (All)</option>
                  {materialData &&
                    materialData?.length > 0 &&
                    materialData?.map((item, id) => {
                      return (
                        <option
                          value={item.id}
                          key={id}
                        >{`${item.material_name}`}</option>
                      );
                    })}
                </select>
              </div>
            </div>
            {/* <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Search by party name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                  />
                </div> */}
            {/* <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                  />
                </div> */}
          </div>
        </div>
        <div>
          <div
            className="ag-theme-quartz"
            style={{ width: "100%", height: 550 }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              context={{ currentPage, pageSize }}
              // domLayout="autoHeight"
              headerHeight={40}
              rowHeight={50}
              sortingOrder={sortingOrder}
              enableCellTextSelection={true}
              // gridOptions={gridOptions}
              rowSelection={"multiple"} // For row selection
              suppressRowClickSelection={true} // For row selection
              suppressCellSelection={true} // For row selection
              onGridReady={onGridReady}
              overlayLoadingTemplate={
                '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
              }
              onCellValueChanged={onCellValueChanged}
              onSelectionChanged={onSelectionChanged}
            />
          </div>
        </div>
        <AddMaterialConsumptionVal
          //   setimgfile={setimgfile}
          formRef={formRef}
          getData={getData}
        />
        <UpdateMaterialConsumptionVal
          selectedRowsData={selectedRowsData}
          updateHandleChange={updateHandleChange}
          getData={getData}
        />
      </div>
      <Pagination
        currentPage={currentPage}
        totalRecords={totalRecords}
        pageSize={pageSize}
        totalPages={totalPages}
        startItem={startItem}
        endItem={endItem}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};

export default MaterialConsumptionVal;
